import { Avatar } from 'antd';

const COLORS = ['#f56a00', '#7265e6', '#00a2ae', '#1677ff', '#52c41a', '#eb2f96', '#fa8c16', '#13c2c2'];

const initials = (name) => (name || '?')
    .split(/\s+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((w) => w[0].toUpperCase())
    .join('');

const colorOf = (name) => {
    let h = 0;
    for (const ch of name || '') h = (h * 31 + ch.charCodeAt(0)) % 997;
    return COLORS[h % COLORS.length];
};

// Аватар-инициалы пользователя с цветом по имени
const UserAvatar = ({ name, size = 24 }) => (
    <Avatar size={size} style={{ background: colorOf(name), fontSize: size * 0.42, flexShrink: 0 }}>
        {initials(name)}
    </Avatar>
);

export default UserAvatar;
